import { parseDbOperationEnded, type DbOperationEnded } from '@papan/types'

/**
 * #1101 — window event for a `db-operation-ended` frame (a background db operation this person's request started has
 * ended; `DbOperationEnded`). The DB editor of that file listens and tells the person; the bell carries the same facts
 * as a stored notification for someone who left the editor.
 */
export const DB_OPERATION_ENDED_EVENT = 'papan:db-operation-ended'

/** Re-dispatch a frame's operation as the window event — dropped unless every field is one this build knows. */
export function dispatchDbOperationEnded(raw: unknown): void {
  const operation = parseDbOperationEnded(raw)
  if (!operation || typeof window === 'undefined' || typeof CustomEvent === 'undefined') return
  window.dispatchEvent(new CustomEvent<DbOperationEnded>(DB_OPERATION_ENDED_EVENT, { detail: operation }))
}
